import Enum from '@square/dashboard-utilities/utils/enum';
export const FlowType = new Enum(['GDPR', 'CCPA']);
export const RequestType = new Enum(['ACCESS', 'SINGLE_DELETION', 'OBJECTION_TO_PROFILING', 'CORRECTION', 'PORTABILITY', 'RESTRICT_PROCESSING', 'GLOBAL_DELETION']);